import { useEffect, useRef } from "react";

export function useAutosizeTextarea(value: string) {
  const textareaRef = useRef<HTMLTextAreaElement>();

  useEffect(() => {
    const el = textareaRef.current;
    if (el) {
      el.style.height = "auto"; // Reset the height
      el.style.height = el.scrollHeight + "px";
    }
  }, [value]);

  return textareaRef;
}
